<script lang="ts" setup>
import { inject, ref, watch } from 'vue';
import CollapseFieldset from '@/components/CollapseFieldset.vue';
import ToggleBox from '@/components/ToggleBox.vue';

import type { Ref } from 'vue';
import type { IManifest } from '@/types/IManifest';

const manifest = inject('manifest') as Ref<IManifest>;
const newTabToggles: Ref<boolean>[] = [];
newTabToggles.push(ref<boolean>(manifest.value.ctaButtons[0].newTab ?? false));
newTabToggles.push(ref<boolean>(manifest.value.ctaButtons[1].newTab ?? false));

watch(newTabToggles[0], (newValue) => {
  manifest.value.ctaButtons[0].newTab = newValue;
});

watch(newTabToggles[1], (newValue) => {
  manifest.value.ctaButtons[1].newTab = newValue;
});

watch(manifest, (newValue) => {
  newTabToggles[0].value = newValue.ctaButtons[0].newTab ?? false;
  newTabToggles[1].value = newValue.ctaButtons[1].newTab ?? false;
});
</script>

<template>
  <CollapseFieldset :enable-collapse="false">
    <template #legend>
      CTA Buttons
    </template>

    <CollapseFieldset v-for="index in 2" :key="index" :enable-collapse="false">
      <template #legend>
        Button {{ index }}
      </template>

      <div class="flex flex-col mb-1">
        <label :for="`cta-button${index}-text`" class="text-xs">Text</label>
        <input :id="`cta-button${index}-text`" v-model="manifest.ctaButtons![index - 1].text" type="text" class="border p-1 text-xs">
      </div>

      <div class="flex flex-col mb-1 last-of-type:mb-0">
        <label :for="`cta-button${index}-link`" class="text-xs">URL</label>
        <input :id="`cta-button${index}-link`" v-model="manifest.ctaButtons![index - 1].path" type="text" class="border p-1 text-xs">
      </div>

      <div class="flex flex-col mb-1 last-of-type:mb-0">
        <ToggleBox v-model="newTabToggles[index - 1].value" label="Open in new tab" />
      </div>
    </CollapseFieldset>
  </CollapseFieldset>
</template>
